export default __webpack_public_path__ + "static/media/guest_16_01.b02e317e.png";